<template>
  <div>
    <!-- 顶部tab切换 -->
    <div class="function-nav">
      <div class="nav-tabs">
        <span v-for="tab in tabs" :key="tab.label" class="tab" :class="{active: activeTab === tab.label}" @click="switchTab(tab)">{{ tab.label }}</span>
      </div>
      <button type="button" class="refresh-btn" @click="onRefresh">刷新</button>
    </div>

    <!-- 投诉订单内容区 -->
    <div v-if="activeTab==='投诉订单'">
      <!-- 筛选区 -->
      <div class="search-section search-section-new">
        <form class="search-form-2x2">
          <div class="form-fields">
            <div class="form-item">
              <label>设备编号：</label>
              <select class="form-input" v-model="query.deviceNo">
                <option value="">全部</option>
                <option v-for="device in deviceOptions" :key="device" :value="device">
                  {{ device }}
                </option>
              </select>
            </div>
            <div class="form-item">
              <label>违规类型：</label>
              <select class="form-input" v-model="query.illegalType">
                <option value="">全部</option>
                <option v-for="type in illegalTypeOptions" :key="type.value" :value="type.value">
                  {{ type.label }}
                </option>
              </select>
            </div>
            <div class="form-item">
              <label>违规人：</label>
              <select class="form-input" v-model="query.complainant">
                <option value="">全部</option>
                <option v-for="employee in employeeOptions" :key="employee" :value="employee">
                  {{ employee }}
                </option>
              </select>
            </div>
            <!-- <div class="form-item">
              <label>处理状态：</label>
              <select class="form-input" v-model="query.status">
                <option value="">全部</option>
                <option v-for="status in statusOptions" 
                    :key="status.value" 
                    :value="status.value">
                  {{ status.label }}
                </option>
              </select>   
            </div>
            <div class="form-item">
              <label>开始日期：</label>
              <input class="form-input" type="date" v-model="query.startDate" />
            </div>
            <div class="form-item">
              <label>结束日期：</label>
              <input class="form-input" type="date" v-model="query.endDate" />
            </div> -->
          </div>
          <div class="form-btns">
            <button type="button" class="search-btn-green" @click="onSearch" :disabled="loading">搜索</button>
            <button type="button" class="clear-btn" @click="onClear" :disabled="loading">清空</button>
          </div>
        </form>
      </div>
      
      <!-- 表格 -->
      <div class="data-section">
        <div class="table-container">
          <table class="data-table">
            <thead>
              <tr>
                <th>序号</th>
                <th>违规编号</th>
                <th>违规人员</th>
                <th>所属公司</th>
                <th>设备编号</th>
                <th>设备名称</th>
                <th>安装位置</th>
                <th>违规类型</th>
                <th>投诉人</th>
                <th>投诉图片</th>
                <th>投诉理由</th>
                <th>投诉时间</th>
                <!-- <th>投诉状态</th>
                <th>操作</th> -->
              </tr>
            </thead>
            <tbody>
              <tr v-if="loading">
                <td colspan="11" style="text-align:center;color:#bbb;">数据加载中...</td>
              </tr>
              <tr v-else-if="orderData.length === 0">
                <td colspan="11" style="text-align:center;color:#bbb;">暂无数据</td>
              </tr>
              <template v-else>
                <tr v-for="(order, index) in orderData" :key="order.id">
                  <td>{{ ((pagination.page - 1) * pagination.pageSize) + index + 1 }}</td>
                  <td>{{ order.violation_number }}</td>
                  <td>{{ order.violator }}</td>
                  <td>{{ order.violator_company }}</td>
                  <td>{{ order.deviceNo }}</td>
                  <td>{{ order.deviceName }}</td>
                  <td>{{ order.install_location }}</td>
                  <!-- <td>{{ order.violation_type_display }}</td> -->
                  <td>
                    <span :class="getViolationTypeClass(order.violation_type_display)">
                      {{ order.violation_type_display }}
                    </span>
                  </td>
                  <td>{{ order.handler || '-' }}</td>  

                  <!-- 违规图片列 - 单张图片显示 -->
                  <td>
                    <div v-if="order.uploadedImages && order.uploadedImages.length > 0" class="single-image-container">
                      <img 
                        :src="getImageUrl(order.uploadedImages[0])" 
                        alt="违规图片" 
                        class="table-single-image"
                        @click="previewSingleImage(order.uploadedImages[0])"
                      >
                    </div>
                    <span v-else class="no-image">无图片</span>
                  </td>

                  <td>{{ order.reason || '-' }}</td>  
                  <td>{{ order.violation_time }}</td>
                  <!-- <td>
                    <span class="status-badge" :class="getStatusClass(order.status)">
                      {{ order.status }}
                    </span>
                  </td> -->
                  <!-- <td>{{ order.processing_time || '-' }}</td> -->
                  <!-- <td>
                    <button class="detail-btn" @click="onViewDetail(order)">详情</button>
                  </td> -->
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div> 

      <!-- 分页 -->
      <div class="pagination" v-if="pagination.total > 0">
        <button class="page-btn" :disabled="pagination.page===1" @click="changePage(1)">«</button>
        <button class="page-btn" :disabled="pagination.page===1" @click="changePage(pagination.page-1)">&lt;</button>
        <span v-for="p in pagination.displayPages" :key="p">
          <button v-if="p !== '...'" class="page-btn" :class="{active:pagination.page===p}" @click="changePage(p)">{{p}}</button>
          <span v-else class="page-ellipsis">...</span>
        </span>
        <button class="page-btn" :disabled="pagination.page===pagination.totalPages" @click="changePage(pagination.page+1)">&gt;</button>
        <button class="page-btn" :disabled="pagination.page===pagination.totalPages" @click="changePage(pagination.totalPages)">»</button>
        <div class="page-jump">
          <input type="text" v-model.number="pagination.pageInput" style="width:50px;"/>
          <button class="jump-btn" @click="jumpPage">跳转</button>
          <span style="margin-left:10px;">共{{pagination.total}}条数据</span>
        </div>
      </div>
    </div>

    <!-- 投诉统计内容区 -->
    <div v-else-if="activeTab==='投诉统计'">
      <!-- 筛选区 -->
      <div class="search-section search-section-new">
        <form class="search-form-2x2">
          <div class="form-fields">
            <div class="form-item">
              <label>开始日期：</label>
              <input class="form-input" type="date" v-model="statQuery.startDate" />
            </div>
            <div class="form-item">
              <label>结束日期：</label>
              <input class="form-input" type="date" v-model="statQuery.endDate" />
            </div>
          </div>
          <div class="form-btns">
            <button type="button" class="search-btn-green" @click="onStatSearch" :disabled="loading">搜索</button>
            <button type="button" class="clear-btn" @click="onStatClear" :disabled="loading">清空</button>
          </div>
        </form>
      </div>
      
      <!-- 图表数据容器 - 根据是否搜索过决定显示内容 -->
      <div v-if="!statsSearched" class="no-data-container">
        <!-- <div class="no-data-text">暂无数据，请点击搜索查看图表</div> -->
        <div class="prompt-content">
          <div class="prompt-icon">📊</div>
          <div class="prompt-text">请从上方点击搜索查看使用统计数据</div>
        </div>
      </div>
      <div v-else class="data-container">  
        <div class="container-top">
          <!-- 投诉处理情况统计 -->
          <div class="container-left">
            <div class="chart-title">
              <div class="chart-label">
                <span>投诉处理情况统计</span>
              </div>
              <div class="chart-icon">
                <!-- <span  style="cursor: pointer;">📥</span> -->
                <!-- <span @click="handleDownload1" style="cursor: pointer;">📥</span> -->
              </div>
            </div>
            <div class="chart-container">
              <span style="font-size: 20px;margin-bottom: 10px;font-weight: bold;">
                投诉总数量
              </span>
              <span style="width: 250px;background-color: lightblue; color: #333; font-size: 30px; margin-bottom: 50px;padding: 4px 10px; border-radius: 4px; margin-left: 10px;">
                {{ statisticsData?.processing_efficiency?.total || 0 }} 次
              </span>
              <!-- <div style="display: flex; flex-direction: column; justify-content: center; align-items: flex-start;">
                <span style="margin-bottom: 10px; margin-left: 10px; font-size: 18px;">✅ 已处理：{{ statisticsData?.processing_efficiency?.resolved?.count || 0 }}件 ({{ statisticsData?.processing_efficiency?.resolved?.percentage || 0 }}%)</span>
                <span style="margin-bottom: 10px; margin-left: 10px; font-size: 18px;">🔁 处理中：{{ statisticsData?.processing_efficiency?.in_progress?.count || 0 }}件 ({{ statisticsData?.processing_efficiency?.in_progress?.percentage || 0 }}%)</span>
                <span style="margin-bottom: 10px; margin-left: 10px; font-size: 18px;">❌ 未处理：{{ statisticsData?.processing_efficiency?.open?.count || 0 }}件 ({{ statisticsData?.processing_efficiency?.open?.percentage || 0 }}%)</span>
              </div> -->
            </div>  
          </div>
          <!-- 投诉数量统计 -->
          <div class="container-right">
            <div class="chart-title">
              <div class="chart-label">
                <span>投诉数量统计</span>
              </div>
              <div class="chart-icon">
                <!-- <span  style="cursor: pointer;">📥</span> -->
                <!-- <span @click="handleDownload2" style="cursor: pointer;">📥</span> -->
              </div>
            </div>
            <div class="chart-container">
              <div class="chart-wrapper" v-if="complaintCountData?.timeRangeX?.length">
                <EchartsLineChart
                  ref="lineChartRef"
                  :time-data="complaintCountData.timeRangeX"
                  :chart-data="complaintCountData.complaintDataY"
                  :show-title="false"
                  :show-legend="true"
                  width="100%"
                  height="320px"
                  :legend-position="'top'"
                  :show-toolbox="false"
                  :download-file-name="'投诉数量统计'"
                  :unit="'单位：单'"
                  :yMax="yDeviceDataMaxValue"
                />
              </div>
              <div v-else style="height:400px; display:flex; align-items:center; justify-content:center; color:#999;">暂无数据</div>
            </div>
          </div>
        </div>
        <div class="container-bottom">
          <!-- 投诉类型统计 -->
          <div class="container-left">
            <div class="chart-title">
              <div class="chart-label">
                <span>投诉类型统计</span>
              </div>
              <div class="chart-icon">
                <!-- <span  style="cursor: pointer;">📥</span> -->
                <!-- <span @click="handleDownload3" style="cursor: pointer;">📥</span> -->
              </div>
            </div>
            <div class="chart-container" style="display: flex; flex-direction: row; justify-content: center; align-items: center;" > 
              <div class="pie-chart" v-if="complaintTypeData?.length">
                <EchartsDoughnutChart
                  ref="doughnutChart1"
                  title="投诉类型"
                  :chart-data="complaintTypeData"
                  :legend-orient="'vertical'"
                  :radius="['20%', '40%']"
                  :legend-position="'bottom'"
                  :title-gap="30"
                  :legend-gap="50"
                  height="100%"
                  width="100%"
                  :show-toolbox="false"
                  :show-label="false"
                  :show-legend-data="true"
                  :legend-data-formatter="'{name}: {value} ({percent}%)'"
                />
              </div>
              <div v-else class="pie-chart" style="justify-content:center; color:#999;">暂无数据</div>
              <div class="pie-chart" v-if="complaintRateData?.length">
                <EchartsDoughnutChart
                  ref="doughnutChart2"
                  title="投诉来源(设备)"
                  :chart-data="complaintRateData"
                  :legend-position="'bottom'"
                  :legend-orient="'vertical'"
                  :radius="['20%', '40%']"
                  :title-gap="30"
                  :legend-gap="15"
                  height="100%"
                  width="100%"
                  :show-toolbox="false"
                  :show-label="false"
                  :show-legend-data="true"
                  :legend-data-formatter="'{name}: {value} ({percent}%)'"
                />
              </div>
              <div v-else class="pie-chart" style="justify-content:center; color:#999;">暂无数据</div>   
            </div>
          </div> 
          <!-- 处理时长统计 -->
          <div class="container-right">
            <div class="chart-title">
              <div class="chart-label">
                <span>处理时长统计</span>
              </div>
              <div class="chart-icon">
                <!-- <span @click="handleDownload4" style="cursor: pointer;">📥</span> -->
                <!-- <span  style="cursor: pointer;">📥</span> -->
              </div>
            </div>
            <div class="chart-container">
              <div class="chart-wrapper" v-if="dealTimeData?.timeMonthX?.length">
                <EchartsBarChart
                  ref="barChartRef"
                  :x-axis-data="dealTimeData.timeMonthX"
                  :series-data="dealTimeData.timeDataY"
                  :colors="barColors"
                  :show-legend="true"
                  :legend-position="'top-right'"
                  :yAxisName="'单位：单'"
                  height="320px"
                  width="100%"
                  :show-toolbox="false"
                  :download-file-name="'处理时长统计'"
                />
              </div>
              <div v-else style="height:400px; display:flex; align-items:center; justify-content:center; color:#999;">暂无数据</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 详情查看模态框（只读） -->
    <div v-if="showDetailDialog" class="detail-dialog-overlay">
      <div class="detail-dialog">
        <div class="dialog-header">
          <h3>投诉详情 - {{ detailOrder ? detailOrder.violation_number : '' }}</h3>
          <span class="close-btn" @click="closeDetailDialog">×</span>
        </div>
        <div class="dialog-content">
          <div v-if="detailOrder" class="detail-form">
            <div class="form-row">
              <div class="form-group">
                <label>违规编号：</label>
                <span class="form-value">{{ detailOrder.violation_number }}</span>
              </div>
              <div class="form-group">
                <label>设备名称：</label>
                <span class="form-value">{{ detailOrder.deviceName }}</span>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group">
                <label>设备编号：</label>
                <span class="form-value">{{ detailOrder.deviceNo }}</span>
              </div>
              <div class="form-group">
                <label>安装位置：</label>
                <span class="form-value">{{ detailOrder.install_location }}</span>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group">
                <label>违规类型：</label>
                <span class="form-value">{{ detailOrder.violation_type }}</span>
              </div>
              <div class="form-group">
                <label>违规人：</label>
                <span class="form-value">{{ detailOrder.violator }}</span>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group">
                <label>所属公司：</label>
                <span class="form-value">{{ detailOrder.violator_company }}</span>
              </div>
              <div class="form-group">
                <label>违规时间：</label>
                <span class="form-value">{{ detailOrder.violation_time }}</span>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group">
                <label>处理状态：</label>
                <span class="form-value status-badge" :class="getStatusClass(detailOrder.status)">
                  {{ detailOrder.status }}
                </span>
              </div>
              <div class="form-group">
                <label>处理人：</label>
                <span class="form-value">{{ detailOrder.handler || '-' }}</span>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group">
                <label>处理时间：</label>
                <span class="form-value">{{ detailOrder.processing_time || '-' }}</span>
              </div>
              <div class="form-group">
                <label>处理结果：</label>
                <span class="form-value">
                  {{ detailOrder.reviewResult === 'approved' ? '通过' : 
                     detailOrder.reviewResult === 'rejected' ? '驳回' : '-' }}
                </span>
              </div>
            </div>
            
            <div class="evidence-section">
              <div class="section-title">违规证据</div>
              <div class="form-group full-width">
                <label>违规图片：</label>
                <div class="image-container">
                  <div v-if="detailOrder.uploadedImages && detailOrder.uploadedImages.length > 0" class="image-list">
                    <div 
                      v-for="(image, index) in detailOrder.uploadedImages" 
                      :key="index" 
                      class="detail-image-item"
                    >
                      <img 
                        :src="getImageUrl(image)" 
                        alt="违规图片" 
                        @click="previewSingleImage(image)"
                      >
                    </div>
                  </div>
                  <span v-else class="no-image-text">暂无图片</span>
                </div>
              </div>
              <div class="form-group full-width">
                <label>违规说明：</label>
                <div class="desc-box">{{ detailOrder.complaintDesc || '暂无说明' }}</div>
              </div>
            </div>

            <div v-if="detailOrder.status === '已处理'" class="process-section">
              <div class="section-title">处理信息</div>
              <div class="form-group full-width">
                <label>处理说明：</label>
                <div class="desc-box">{{ detailOrder.reviewOpinion || '无' }}</div>
              </div>
              <div v-if="detailOrder.reviewResult === 'rejected' && detailOrder.rejectReason" class="form-group full-width">
                <label>驳回原因：</label>
                <div class="desc-box">{{ detailOrder.rejectReason }}</div>
              </div>
            </div>

            <div class="dialog-actions">
              <button type="button" class="close-btn-action" @click="closeDetailDialog">关闭</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 图片预览模态框 -->
    <div v-if="showImagePreview" class="image-preview-overlay" @click="closeImagePreview">
      <div class="image-preview-modal" @click.stop>
        <span class="preview-close-btn" @click="closeImagePreview">×</span>
        <img :src="currentPreviewImage" alt="预览图片">
      </div>
    </div>

  </div>
</template>

<script>
import EchartsLineChart from '@/components/EchartsLineChart.vue';
import EchartsBarChart from '@/components/EchartsBarChart.vue';
import EchartsDoughnutChart from '@/components/EchartsDoughnutPieChart.vue';

import {
  listComplaints,
  getStatistics
} from '@/api/laundry.js';

const statusMap = {
  API_TO_VIEW: {
    open: '未处理',
    resolved: '已处理',
    in_progress: '处理中',
    closed: '已关闭'
  }
};

export default {
  name: 'LaundryComplaintHandling',
  components: {
    EchartsLineChart,
    EchartsBarChart,
    EchartsDoughnutChart
  },

  data() {
    return {
      tabs: [
        { label: '投诉订单' },
        { label: '投诉统计' }
      ],
      activeTab: '投诉订单',
      loading: false,
      
      // 标记是否搜索过统计图表
      statsSearched: false,
      // 存储原始统计数据
      statisticsData: null,

      // 状态选项
      statusOptions: [
        { label: '全部', value: '' },
        { label: '未处理', value: 'open' },
        { label: '已处理', value: 'resolved' },
        { label: '处理中', value: 'in_progress' },
        { label: '已关闭', value: 'closed' },
      ],
      
      // 查询参数
      query: {
        deviceNo: '',
        illegalType: '',
        complainant: '',
        status: '',
        startDate: '',
        endDate: ''
      },
      statQuery: {
        startDate: '',
        endDate: ''
      },
      
      // 筛选选项
      deviceOptions: [],
      illegalTypeOptions: [
        { label: '全部', value: '' },
        { label: '未取衣', value: 'unclaimed' },
        { label: '违禁物品', value: 'prohibited' },
    ],
      employeeOptions: [],
      
      // 数据
      orderData: [],
      allData: [],
      
      // 图表数据
      complaintCountData: null,
      complaintTypeData: [],
      complaintRateData: [],
      dealTimeData: null,
      
      // 对话框状态
      showDetailDialog: false,
      showImagePreview: false,
      detailOrder: null,
      currentPreviewImage: '',

      // 分页参数
      pagination: {
        page: 1,
        pageSize: 5,
        total: 0,
        totalPages: 0,
        displayPages: [],
        pageInput: 1
      },

      barColors: ['#5470c6', '#ee6666', '#fac858', '#73c0de', '#3ba272'],
      // 防抖定时器
      debounceTimer: null,
      
      // API基础URL
      baseURL: process.env.VUE_APP_BASE_URL || ''
    };
  },
  
  computed: {
    // 计算总页数
    totalPagesCount() {
      return Math.ceil(this.pagination.total / this.pagination.pageSize) || 1;
    },

    // 设备使用统计图表y轴最大值
    yDeviceDataMaxValue() {
      let max = 0;
      this.complaintCountData.complaintDataY.forEach(item => {
        item.data.forEach(value => {
          if (value > max) {
            max = value;
          }
        });
      });
      return max;
    },
  },

  watch: {
    activeTab(newVal) {
      if (newVal === '投诉统计') {
        this.statsSearched = false;
      }
    },

    //监听日期的变化
    'query.startDate'(newVal, oldVal) {
      if (newVal !== oldVal && newVal) {
        this.debounceValidateDate('query');
      }
    },
    'query.endDate'(newVal, oldVal) {
      if (newVal !== oldVal && newVal) {
        this.debounceValidateDate('query');
      }
    },
    'statQuery.startDate'(newVal, oldVal) {
      if (newVal !== oldVal && newVal) {
        this.debounceValidateDate('statQuery');
      }
    },
    'statQuery.endDate'(newVal, oldVal) {
      if (newVal !== oldVal && newVal) {
        this.debounceValidateDate('statQuery');
      }
    },
    
    // 监听总页数变化，更新显示页码
    totalPagesCount: {
      handler(newVal) {
        this.pagination.totalPages = newVal;
        this.updateDisplayPages();
      },
      immediate: true
    },

    // 监听当前页码变化，更新显示页码
    'pagination.page': function() {
      this.updateDisplayPages();
    }
  },

  mounted() {
    this.loadOrderData();
    this.loadAllFilterOptions();
  },

  methods: {
    // 获取完整的图片URL
    getImageUrl(image) {
      if (!image) return '';
      
      if (typeof image === 'string' && (image.startsWith('http://') || image.startsWith('https://'))) {
        return image;
      }
      
      if (typeof image === 'string') {
        if (image.startsWith('/')) {
          return this.baseURL + image;
        }
        return this.baseURL + '/' + image;
      }
      
      return '';
    },

    // 预览单张图片
    previewSingleImage(image) {
      if (!image) return;
      this.currentPreviewImage = this.getImageUrl(image);
      this.showImagePreview = true;
    },

    // 更新显示页码
    updateDisplayPages() {
      const pages = [];
      const total = this.pagination.totalPages;
      const current = this.pagination.page;
      
      if (total <= 7) {
        for (let i = 1; i <= total; i++) {
          pages.push(i);
        }
      } else {
        if (current <= 4) {
          for (let i = 1; i <= 5; i++) {
            pages.push(i);
          }
          pages.push('...');
          pages.push(total);
        } else if (current >= total - 3) {
          pages.push(1);
          pages.push('...');
          for (let i = total - 4; i <= total; i++) {
            pages.push(i);
          }
        } else {
          pages.push(1);
          pages.push('...');
          for (let i = current - 1; i <= current + 1; i++) {
            pages.push(i);
          }
          pages.push('...');
          pages.push(total);
        }
      }
      
      this.pagination.displayPages = pages;
    },

    // 防抖验证日期
    debounceValidateDate(formType) {
      if (this.debounceTimer) clearTimeout(this.debounceTimer);
      
      this.debounceTimer = setTimeout(() => {
        this.validateDateRange(formType);
      }, 500);
    },
    
    // 日期范围验证
    validateDateRange(formType) {
      const startDate = this[formType].startDate;
      const endDate = this[formType].endDate;
      
      if (!startDate || !endDate) return true;
      
      const start = new Date(startDate);
      const end = new Date(endDate);
      
      if (end < start) {
        this.$message.error('结束日期不能早于开始日期');
        this[formType].endDate = '';
        return false;
      }
      
      const diffDays = Math.ceil((end - start) / (1000 * 60 * 60 * 24));
      if (diffDays > 365) {
        this.$message.warning('日期范围不能超过365天');
        this[formType].endDate = '';
        return false;
      }
      
      return true;
    },

    // 关闭图片预览
    closeImagePreview() {
      this.showImagePreview = false;
      this.currentPreviewImage = '';
    },

    // 投诉列表接口映射
    mapComplaintsList(list) {
      return list.map(item => ({
        id: item.id,
        violation_number: item.violation_number,
        deviceName: item.device_name,
        deviceNo: item.device_no,
        install_location: item.install_location,
        violation_type: item.violation_type,
        violation_type_display: item.violation_type_display,
        violator: item.violator,
        violator_company: item.violator_company,
        violation_time: item.violation_time,
        handler: item.handler,
        reason:item.reason,
        status: statusMap.API_TO_VIEW[item.status] || item.status,
        processing_time: item.processing_time,
        complaintDesc: item.description,
        uploadedImages: item.evidence_image_url ? [item.evidence_image_url] : [],
        reviewOpinion: item.review_opinion,
        reviewResult: item.review_result,
        rejectReason: item.reject_reason
      }));
    },

    // 加载投诉订单数据
    async loadOrderData() {
      this.loading = true;
      try {
        const params = {
          pageNo: this.pagination.page,
          pageSize: this.pagination.pageSize,
          device_no: this.query.deviceNo || undefined,
          violation_type: this.query.illegalType || undefined,
          employee_name: this.query.complainant || undefined,
          status: this.query.status || undefined,
          start_date: this.query.startDate|| undefined,
          end_date: this.query.endDate || undefined
        };
        
        const response = await listComplaints(params);
        const res = response.data;

        if (res && res.data) {
          let listData = this.mapComplaintsList(res.data.list || []);
          
          this.pagination.total = res.data.total || 0;
          // this.pagination.page = res.data.pageNum || 1;
          this.pagination.pageSize = res.data.pageSize || 9;
          this.pagination.totalPages = Math.ceil(this.pagination.total / this.pagination.pageSize) || 1;
          
          this.orderData = listData;
          //this.allData = listData;
          // 单独加载全部数据用于筛选选项
          await this.loadAllFilterOptions();
          //this.extractFilterOptions();
        } else {
          this.orderData = [];
          this.pagination.total = 0;
          this.pagination.totalPages = 1;
        }
        
      } catch (error) {
        console.error('加载投诉订单数据失败:', error);
        this.orderData = [];
        this.pagination.total = 0;
        this.pagination.totalPages = 1;
        this.$message.error('获取投诉订单数据失败');
      } finally {
        this.loading = false;
      }
    },

    // 新增方法：加载全部数据用于筛选选项
    async loadAllFilterOptions() {
      try {
        // 构建查询参数（使用当前的查询条件，但不分页）
        const params = {
          pageNo: 1,
          pageSize: 10, // 设置一个较大的值，获取全部数据
          device_no: this.query.deviceNo || undefined,
          violation_type: this.query.illegalType || undefined,
          employee_name: this.query.complainant || undefined,  
          status: this.query.status || undefined,
          start_date:this.query.startDate|| undefined,
          end_date: this.query.endDate|| undefined
        };
  
        
        const response = await listComplaints(params);
        const res = response.data;

        if (res && res.data) {
          const allListData = this.mapComplaintsList(res.data.list || []);
          this.extractFilterOptions(allListData);
        }
      } catch (error) {
        console.error('加载全部筛选选项数据失败:', error);
      }
    },
    // 加载图表数据
    async loadChartData() {
      try {
        if (!this.validateDateRange('statQuery')) {
          return;
        }
        
        const params = {
          start_date: this.statQuery.startDate ||'',
          end_date: this.statQuery.endDate || ''
        };

        const response = await getStatistics(params);
        const res = response.data;
        
        if (res.code === 0 && res.data) {
          this.statisticsData = res.data;
          
          this.complaintCountData = {
            timeRangeX: res.data.trend_statistics?.dates || [],
            complaintDataY: [
              {
                name: '投诉数量',
                data: res.data.trend_statistics?.counts || []
              }
            ]
          };
          
          this.complaintTypeData = res.data.type_statistics?.map(item => ({
            name: item.type,
            value: item.count,
            percent: item.percentage
          })) || [];
          
          this.complaintRateData = res.data.source_statistics?.map(item => ({
            name: item.source,
            value: item.count,
            percent: item.percentage
          })) || [];
          
          this.dealTimeData = {
            timeMonthX: res.data.time_statistics?.hours || [],
            timeDataY: [
              {
                name: '已处理',
                data: res.data.time_statistics?.resolved || []
              },
              {
                name: '未处理',
                data: res.data.time_statistics?.unresolved || []
              }
            ]
          };
          
          this.statsSearched = true;
        } else {
          throw new Error(res.message || '获取图表数据失败');
        }
        
      } catch (error) {
        console.error('加载图表数据失败:', error);
        this.$message.error('加载图表数据失败');
        this.statsSearched = true;
      }
    },
    // 修改 extractFilterOptions 方法，接受数据参数
    extractFilterOptions(data) {
      if (!data || data.length === 0) {
        this.deviceOptions = [];
        this.illegalTypeOptions = [];
        this.employeeOptions = [];
        return;
      }
      
      const devices = data.map(order => order.deviceNo).filter(Boolean);
      this.deviceOptions = [...new Set(devices)];
      
      // const types = data.map(order => order.violation_type).filter(Boolean);
      // this.illegalTypeOptions = [...new Set(types)];
      
      const employees = data.map(order => order.violator).filter(Boolean);
      this.employeeOptions = [...new Set(employees)];
    },
    
    
    // 查看详情
    onViewDetail(order) {
      this.detailOrder = { ...order };
      this.showDetailDialog = true;
    },
    
    // 关闭详情对话框
    closeDetailDialog() {
      this.showDetailDialog = false;
      this.detailOrder = null;
    },
    
    // 格式化日期
    formatDate(dateStr) {
      if (!dateStr) return '';
      return dateStr.replace(/-/g, '/');
    },

    // 下载图表
    handleDownload1() {
      console.log('下载投诉处理情况统计');
    },
    
    handleDownload2() {
      if (this.$refs.lineChartRef) {
        this.$refs.lineChartRef.downloadImage();
      }
    },
    
    handleDownload3() {
      if (this.$refs.doughnutChart1) {
        this.$refs.doughnutChart1.downloadImage();
      }
    },
    
    handleDownload4() {
      if (this.$refs.barChartRef) {
        this.$refs.barChartRef.downloadImage();
      }
    },
    // 搜索
    onSearch() {
      if (!this.validateDateRange('query')) {
        return;
      }
      this.pagination.page = 1;
      this.pagination.pageInput = 1;
      this.loadOrderData();
      this.loadAllFilterOptions();
    },
    
    onStatSearch() {
      if (!this.validateDateRange('statQuery')) {
        return;
      }
      this.loadChartData();
    },
    
    // 清空
    onClear() {
      this.query = {
        deviceNo: '',
        illegalType: '',
        complainant: '',
        status: '',
        startDate: '',
        endDate: ''
      };
      this.pagination.page = 1;
      this.pagination.pageInput = 1;
      this.loadOrderData();
    },
    
    onStatClear() {
      this.statQuery = {
        startDate: '',
        endDate: ''
      };
      this.statisticsData = null;
      this.complaintCountData = null;
      this.complaintTypeData = [];
      this.complaintRateData = [];
      this.dealTimeData = null;
      this.statsSearched = false;
    },
    
    // 切换标签页
    switchTab(tab) {
      this.activeTab = tab.label;
      if (this.activeTab === '投诉订单') {
        this.pagination.page = 1;
        this.pagination.pageInput = 1;
      }
    },
    
    // 刷新
    onRefresh() {
      if (this.activeTab === '投诉订单') {
        this.loadOrderData();
      } else {
        if (this.statsSearched) {
          this.loadChartData();
        } else {
          this.statsSearched = false;
        }
      }
    },
    
    // 分页
    changePage(newPage) {
      if (newPage >= 1 && newPage <= this.pagination.totalPages) {
        this.pagination.page = newPage;
        this.pagination.pageInput = newPage;
        this.loadOrderData();
      }
    },
    
    jumpPage() {
      let targetPage = parseInt(this.pagination.pageInput);
      if (isNaN(targetPage) || targetPage < 1) targetPage = 1;
      else if (targetPage > this.pagination.totalPages) targetPage = this.pagination.totalPages;
      this.changePage(targetPage);
    },
    
    // 获取状态样式
    getStatusClass(status) {
      const statusMap = {
        '未处理': 'status-pending',
        '处理中': 'status-processing',
        '已处理': 'status-completed',
        '已关闭': 'status-closed'
      };
      return statusMap[status] || 'status-pending';
    },

    // 根据违规类型返回对应的CSS类名
    getViolationTypeClass(type) {
      const typeClassMap = {
        '未取衣': 'violation-type-unclaimed',
        '违禁物品': 'violation-type-prohibited',
        
      };
      return typeClassMap[type] || 'violation-type-default';
    }
  }
};
</script>

<style scoped>
/* 全局样式 */
div {
  box-sizing: border-box;

}
/* div {
  box-sizing: border-box;
  overflow: hidden; 
} */

/* 违规类型通用样式 */
.violation-type-unclaimed,
.violation-type-prohibited,
.violation-type-default {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: bold;
  color: #fff;
}

/* 默认样式 - 灰色 */
.violation-type-default {

  background-color: #9e9e9e;

}

/* 未取衣样式 - 橙色 */
.violation-type-unclaimed {

  background-color: #ff9800;

}

/* 违禁物品样式 - 红色 */
.violation-type-prohibited {

  background-color: #e74c3c;

}

/* 单张图片容器样式 */
.single-image-container {
  width: 50px;
  height: 50px;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.2s;
}

.single-image-container:hover {
  transform: scale(1.1);
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
}

.table-single-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.no-image {
  color: #999;
  font-size: 12px;
}

/* 暂无数据容器样式 */
.no-data-container {
  /* height: 200px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  border-radius: 4px;
  margin-top: 20px; */
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 300px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

.no-data-text {
  color: #999;
  font-size: 16px;
}
.prompt-content {
  text-align: center;
  padding: 40px;
}

.prompt-icon {
  font-size: 48px;
  margin-bottom: 20px;
  opacity: 0.6;
}

.prompt-text {
  font-size: 16px;
  color: #666;
  font-weight: 500;
}
/* 数据容器样式 */
.data-container{
  height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 10px;
}

/* 顶部容器样式 */
.container-top{
  width: 100%;
  min-height: 6px;
  display: flex;
  flex-direction: row;
  margin-bottom: 10px;
}

/* 底部容器样式 */
.container-bottom{
  min-height: 60px;
  width: 100%;
  display: flex;
  flex-direction: row;
  margin-top: 10px;
}

/* 左侧容器样式 */
.container-left{
  width: 30%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  margin-right: 10px;
}

/* 右侧容器样式 */
.container-right{
  width: 70%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  margin-left: 10px;
}

/* 图表标题样式 */
.chart-title{
  width: 100%;
  height: 15%;
  display: flex;
  padding: 20px 10px 0 10px;
  border-bottom: 1px solid #e9ecef;
}

/* 图表标签样式 */
.chart-label{
  width: 80%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 20px;
  font-weight: bold;
  margin-left: 10px;
  color: #666;
}

/* 图表图标样式 */
.chart-icon{
  width: 20%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-size: 20px;
  margin-right: 20px;
}

/* 图表容器样式 */
.chart-container{
  width: 100%;
  height: 85%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #666;
}

/* 图表样式 */
.chart-wrapper{
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* 投诉订单列表样式 */
.pie-chart{
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 详情按钮样式 */
.detail-btn {
  background-color: #1890ff;
  color: white;
  border: none;
  padding: 4px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  min-width: 60px;
}

.detail-btn:hover {
  background-color: #40a9ff;
}

/* 详情对话框样式 */
.detail-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 20px;
}

.detail-dialog {
  background-color: white;
  border-radius: 8px;
  width: 700px;
  max-width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 1px solid #e8e8e8;
}

.dialog-header h3 {
  margin: 0;
  font-size: 18px;
  color: #333;
  font-weight: 600;
}

.close-btn {
  font-size: 24px;
  cursor: pointer;
  color: #999;
  line-height: 1;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-btn:hover {
  color: #333;
}

.dialog-content {
  padding: 24px;
}

.detail-form {
  width: 100%;
}

.form-row {
  display: flex;
  gap: 20px;
  margin-bottom: 16px;
}

.form-group {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.form-group.full-width {
  flex: 0 0 100%;
}

.form-group label {
  margin-bottom: 6px;
  font-weight: 500;
  color: #666;
  font-size: 14px;
}

.form-value {
  padding: 8px 12px;
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 4px;
  font-size: 14px;
  color: #333;
  min-height: 36px;
  display: flex;
  align-items: center;
}

/* 状态标签样式 */
.status-badge {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
}

.status-processing {
  background-color: #fff7e6;
  color: #fa8c16;
  border: 1px solid #ffd591;
}

.status-completed {
  background-color: #f6ffed;
  color: #52c41a;
  border: 1px solid #b7eb8f;
}

.status-pending {
  background: #fff1f0;
  color: #f5222d;
  border: 1px solid #ffa39e;
}

.status-closed {
  background-color: #f5f5f5;
  color: #8c8c8c;
  border: 1px solid #d9d9d9;
}

/* 标题样式 */
.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin: 20px 0 12px 0;
  padding-bottom: 8px;
  border-bottom: 1px solid #e8e8e8;
}

/* 图片容器样式 */
.image-container {
  margin-top: 10px;
}

.image-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.detail-image-item {
  width: 100px;
  height: 100px;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  overflow: hidden;
  cursor: pointer;
}

.detail-image-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s;
}

.detail-image-item:hover img {
  transform: scale(1.05);
}

.no-image-text {
  color: #999;
  font-size: 14px;
  padding: 8px 0;
}

/* 描述框 */
.desc-box {
  padding: 12px;
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 4px;
  font-size: 14px;
  color: #333;
  min-height: 60px;
  line-height: 1.5;
}

/* 对话框按钮 */
.dialog-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #e8e8e8;
}

.close-btn-action {
  padding: 8px 24px;
  background-color: #1890ff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background 0.3s;
}

.close-btn-action:hover {
  background-color: #40a9ff;
}

/* 图片预览模态框 */
.image-preview-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1100;
}

.image-preview-modal {
  position: relative;
  max-width: 90%;
  max-height: 90%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.image-preview-modal img {
  max-width: 90vw;
  max-height: 80vh;
  object-fit: contain;
}

.preview-close-btn {
  position: absolute;
  top: -40px;
  right: 0;
  color: white;
  font-size: 30px;
  cursor: pointer;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.preview-close-btn:hover {
  color: #1890ff;
}
</style>